import { styled, css } from "@mui/material/styles";
import { keyframes } from "@mui/system";

interface LoaderProps {
  position?: string;
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
  width?: string;
  height?: string;
  transform?: string;
  margin?: string;
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const spinAnimation = css`
  ${spin} 1.2s linear infinite;
`;

const StyledLoaderBlurredContainer = styled("div")<{
  fullPage?: boolean;
  whiteBlur?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: ${({ fullPage }) => (fullPage ? "fixed" : "absolute")};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ whiteBlur }) =>
    whiteBlur ? "rgba(255, 255, 255, 0.4)" : "rgba(82, 90, 106, 0.4)"};
  z-index: 10;
`;

const StyledLoaderContainer = styled("div")<LoaderProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width ?? "80px"};
  height: ${({ height }) => height ?? "80px"};
  ${({ position }) => position && `position: ${position}`};
  ${({ transform }) => transform && `transform: ${transform}`};
  ${({ top }) => top && `top: ${top}`};
  ${({ left }) => left && `left: ${left}`};
  ${({ bottom }) => bottom && `bottom: ${bottom}`};
  ${({ right }) => right && `right: ${right}`};
  ${({ margin }) => margin && `margin: ${margin}`};
`;

const StyledLoader = styled("img")`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  animation: ${spinAnimation};
`;

export { StyledLoaderContainer, StyledLoader, StyledLoaderBlurredContainer };
